<template>
  <v-col class="d-flex align-items-center">
    <div class="d-flex justify-content-end pre-create-button-area w-100">
      <div class="button-with-error">
        <v-btn
          class="exec-btn me-2"
          :disabled="isDisabled"
          @click="handleBulkAggregate"
        >
          {{ i18n.global.t('pages.monthlyReport.preCreateButton.bulkAggregate') }}
        </v-btn>
        <div class="error-message-area">
          <ValidationErrors :messages="errorMessages" />
        </div>
      </div>
    </div>
  </v-col>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { useAuth } from "@/services/user/Auth0UserProvider";
import i18n from '@/lang/i18n';
import Api from "@/services/api/ApiServiceFabrick";
import ValidationErrors from '@/components/Common/ValidationErrors.vue';
import { isLaravelValidationError } from '@/types/LaravelValidationError';

const props = defineProps<{
  operationOfficeId?: number | null;
  yearMonth?: string | null;
  showFlash?: (message: string, type: string, fadeout: boolean) => void;
}>();

const { loginWithRedirect } = useAuth();
const processing = ref(false);
const errorMessages = ref<string[]>([]);

const isDisabled = computed(() => {
  return processing.value || !props.operationOfficeId || !props.yearMonth;
});

async function handleBulkAggregate() {
  if (!props.operationOfficeId || !props.yearMonth) {
    return;
  }

  processing.value = true;
  errorMessages.value = [];
  try {
    await Api().createMonthlyReportPreCreate({
      operation_office_id: props.operationOfficeId,
      year_month: props.yearMonth
    });
    if (props.showFlash) {
      props.showFlash(
        i18n.global.t('pages.monthlyReport.preCreateButton.bulkAggregateStarted'),
        'success',
        true
      );
    }
  } catch (error: unknown) {
    if (isLaravelValidationError(error)) {
      const res = error.response;
      switch (res.status) {
        case 401:
          loginWithRedirect({ appState: { targetUrl: location.pathname } })
          break
        case 403:
          location.reload()
          break
        case 422:
          if (res.data.errors) {
            for (const msgs of Object.values(res.data.errors)) {
              errorMessages.value.push(...msgs);
            }
          }
          break;
      }
    } else {
      console.error(error);
    }
  } finally {
    processing.value = false;
  }
}

</script>

<style scoped>
.pre-create-button-area .exec-btn.v-btn--disabled {
  background-color: rgb(71, 170, 196) !important;
}

.button-with-error {
  position: relative;
}

.error-message-area {
  position: absolute;
  top: 100%;
  right: 0;
  min-height: 0;
  white-space: nowrap;
}
</style>
